import editStyles from "../../styles/editForm.module.css";
import styles from "../../styles/applicationDetail.module.css";
import type { NotesTabApplicantFlagsSectionProps } from "../../types";

export function NotesTabApplicantFlagsSection({
  tab,
}: NotesTabApplicantFlagsSectionProps) {
  const {
    applicationData,
    accountSuspended,
    previousChargeback,
    previousDefault,
    canExecutiveOverride,
    executiveSubmitting,
    handleChargebackExecutiveOverride,
    handleDefaultExecutiveOverride,
  } = tab;

  return (
    <>
      <div className={styles.section} data-testid="application-notes-tab-section-account-suspended">
        <div className={styles.infoRow}>
          <div className={styles.infoColumn}>
            <h6>Account Suspended</h6>
            <p>{accountSuspended ? "Yes" : "No"}</p>
          </div>
        </div>
      </div>

      <div className={styles.section} data-testid="application-notes-tab-section-previous-chargeback">
        <div className={styles.infoRow}>
          <div className={styles.infoColumn}>
            <h6>Previous Lost Chargeback</h6>
            <p>{previousChargeback ? "Yes" : "No"}</p>
          </div>
        </div>
        {previousChargeback && canExecutiveOverride ? (
          <div className={styles.infoRow} style={{ marginTop: "12px" }}>
            <div className={styles.infoColumn}>
              <span style={{ marginRight: "16px" }}>Executive Override :</span>
              <label
                className={editStyles.radioLabel}
                style={{ marginRight: "16px" }}
              >
                <input
                  type="radio"
                  name="previous_chargeback_executive_override"
                  data-testid="application-notes-tab-chargeback-override-yes-input"
                  value="1"
                  disabled={executiveSubmitting}
                  checked={
                    applicationData?.previous_chargeback_executive_override ===
                    "1"
                  }
                  onChange={() => void handleChargebackExecutiveOverride("1")}
                />
                <span>Yes</span>
              </label>
              <label className={editStyles.radioLabel}>
                <input
                  type="radio"
                  name="previous_chargeback_executive_override"
                  data-testid="application-notes-tab-chargeback-override-no-input"
                  value="0"
                  disabled={executiveSubmitting}
                  checked={
                    applicationData?.previous_chargeback_executive_override ===
                    "0"
                  }
                  onChange={() => void handleChargebackExecutiveOverride("0")}
                />
                <span>No</span>
              </label>
            </div>
          </div>
        ) : null}
      </div>

      <div className={styles.section} data-testid="application-notes-tab-section-previous-default">
        <div className={styles.infoRow}>
          <div className={styles.infoColumn}>
            <h6>Previous or Active Default</h6>
            <p>{previousDefault ? "Yes" : "No"}</p>
          </div>
        </div>
        {previousDefault && canExecutiveOverride ? (
          <div className={styles.infoRow} style={{ marginTop: "12px" }}>
            <div className={styles.infoColumn}>
              <span style={{ marginRight: "16px" }}>Executive Override :</span>
              <label
                className={editStyles.radioLabel}
                style={{ marginRight: "16px" }}
              >
                <input
                  type="radio"
                  name="previous_default_executive_override"
                  data-testid="application-notes-tab-default-override-yes-input"
                  value="1"
                  disabled={executiveSubmitting}
                  checked={
                    applicationData?.previous_default_executive_override === "1"
                  }
                  onChange={() => void handleDefaultExecutiveOverride("1")}
                />
                <span>Yes</span>
              </label>
              <label className={editStyles.radioLabel}>
                <input
                  type="radio"
                  name="previous_default_executive_override"
                  data-testid="application-notes-tab-default-override-no-input"
                  value="0"
                  disabled={executiveSubmitting}
                  checked={
                    applicationData?.previous_default_executive_override === "0"
                  }
                  onChange={() => void handleDefaultExecutiveOverride("0")}
                />
                <span>No</span>
              </label>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}
